import React from 'react';
import LinkWrapper from 'containers/LinkWrapperContainer';
import { routeMap } from 'router/routes';
import config from 'config';

export function ArmyMeasuresRequestLink() {
  if (config.isInspectorArm) {
    return null;
  }

  return (
    <LinkWrapper href={routeMap.requestArmyMeasures} className="link white mt-3">
      Сообщить об отсутствии мер поддержки мобилизованных
    </LinkWrapper>
  );
}
